<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
            >
            <el-breadcrumb-item
                :to="{ path: '/raceManagement/camp/campListData' }"
                >常见问题管理</el-breadcrumb-item
            >
            <el-breadcrumb-item>常见问题列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-page-header @back="goBack"></el-page-header>
        <el-card style="margin-top: 15px">
            <el-row class="title_row">
                <el-col>
                    <span>信息筛选</span>
                </el-col>
            </el-row>
            <el-form
                :model="queryForm"
                class="filter_Form"
                label-width="80px"
                ref="queryFormRef"
            >
                <el-row :gutter="50">
                    <el-col :span="6">
                        <el-form-item label="问题" prop="question">
                            <el-input
                                v-model="queryForm.question"
                                placeholder="请输入问题"
                                size="small"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="答案" prop="answer">
                            <el-input
                                v-model="queryForm.answer"
                                placeholder="请输入答案"
                                size="small"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否启用" prop="state">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="queryForm.state"
                                clearable
                            >
                                <el-option
                                    v-for="item in dict_state"
                                    :key="item.dictCode"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-row :gutter="20" type="flex" justify="end">
                <el-col :span="2">
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        size="small"
                        style="width: 100%"
                        @click="getDataList"
                        >查询</el-button
                    >
                </el-col>
                <el-col :span="2">
                    <el-button
                        type="warning"
                        icon="el-icon-refresh-right"
                        size="small"
                        style="width: 100%"
                        @click="queryReset"
                        >重置</el-button
                    >
                </el-col>
            </el-row>
        </el-card>
        <el-card style="margin-top: 15px">
            <el-row class="title_row">
                <el-col :span="12">
                    <span>问题列表</span>
                </el-col>
                <el-col :span="12">
                    <div style="text-align: right">
                        <el-button
                            type="success"
                            size="small"
                            @click="handleAdd"
                            icon="el-icon-circle-plus-outline"
                            >新增问题</el-button
                        >
                        <el-button
                            type="primary"
                            size="small"
                            @click="campProblemsExport"
                            icon="el-icon-download"
                            >导出信息</el-button
                        >
                    </div>
                </el-col>
            </el-row>
            <el-table
                header-cell-class-name="tableHeaderStyle"
                :data="dataList"
                border
                stripe
            >
                <el-table-column
                    align="center"
                    label="#"
                    type="index"
                    width="50px"
                ></el-table-column>
                <el-table-column
                    align="center"
                    label="序号"
                    prop="sort"
                    width="80px"
                ></el-table-column>
                <el-table-column
                    align="center"
                    label="问题"
                    prop="question"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    align="center"
                    label="答案"
                    prop="answer"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    align="center"
                    label="备注"
                    prop="note"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    align="center"
                    label="是否有效"
                    prop="state"
                    width="120px"
                >
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.state"
                            :active-value="true"
                            :inactive-value="false"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            @change="stateChange(scope.row)"
                        ></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="140px">
                    <template scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="handleDelete(scope.row)"
                            >删除</el-button
                        >
                        <el-button
                            type="text"
                            size="small"
                            @click="handleEdit(scope.row)"
                            >编辑</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryForm.pageNum"
                :page-sizes="[10, 20, 40, 80]"
                :page-size="queryForm.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </el-card>
        <!-- 新增/编辑对话框 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="addInfoDialog"
            width="50%"
        >
            <el-form
                :model="addInfoModel"
                label-width="100px"
                ref="addInfoFormRef"
                :rules="addInfoRules"
                style="width: 100%"
            >
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="问题" prop="question">
                            <el-input
                                v-model="addInfoModel.question"
                                placeholder="请输入问题"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="序号" prop="sort">
                            <el-input-number
                                v-model="addInfoModel.sort"
                                :min="0"
                                placeholder="请输入序号"
                                style="width: 100%"
                            ></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="答案" prop="answer">
                            <el-input
                                type="textarea"
                                :rows="4"
                                v-model="addInfoModel.answer"
                                placeholder="请输入答案"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="备注" prop="note">
                            <el-input
                                type="textarea"
                                :rows="3"
                                v-model="addInfoModel.note"
                                placeholder="请输入备注"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="是否有效" prop="state">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="addInfoModel.state"
                            >
                                <el-option
                                    v-for="item in dict_state"
                                    :key="item.dictCode"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addInfoDialog = false">取 消</el-button>
                <el-button type="primary" @click="saveInfo"
                    >保 存</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
  campCommonProblemList,
  campCommonProblemCreate,
  campCommonProblemEdit,
  campCommonProblemDel,
  campCommonProblemStatus
} from '@/http/api'

export default {
  data () {
    return {
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        question: '',
        answer: '',
        state: '',
        type: 'camp'
      },
      dict_state: this.$userInfo.dictExamstatus(),
      total: 0,
      dataList: [],
      addInfoDialog: false,
      dialogTitle: '新增问题',
      addInfoModel: {
        id: '',
        question: '',
        answer: '',
        note: '',
        sort: 0,
        state: true,
        type: 'camp'
      },
      addInfoRules: {
        question: [{ required: true, message: '请输入问题', trigger: 'blur' }],
        answer: [{ required: true, message: '请输入答案', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入序号', trigger: 'blur' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  created () {
    this.getDataList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 获取列表数据
    getDataList () {
      // 处理查询参数：如果 state 是布尔值，需要转换为数字或保持为空
      const queryParams = { ...this.queryForm }
      if (queryParams.state === true) {
        queryParams.state = 1
      } else if (queryParams.state === false) {
        queryParams.state = 0
      }

      campCommonProblemList(queryParams).then((res) => {
        const list = res.data.list || res.data || []
        // 将状态值转换为布尔值
        this.dataList = list.map(item => {
          // 统一转换为布尔值
          if (item.state === 1 || item.state === '1' || item.state === true) {
            item.state = true
          } else if (item.state === 0 || item.state === '0' || item.state === false) {
            item.state = false
          } else {
            // 默认值
            item.state = false
          }
          return item
        })
        this.total = res.data.total || 0
      }).catch((err) => {
        console.log('err', err)
        this.$message.error('获取列表数据失败')
      })
    },
    // 查询
    queryReset () {
      this.$refs.queryFormRef.resetFields()
      this.queryForm.pageNum = 1
      this.queryForm.type = 'camp'
      this.getDataList()
    },
    // 分页
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getDataList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getDataList()
    },
    // 新增
    handleAdd () {
      this.dialogTitle = '新增问题'
      this.addInfoModel = {
        id: '',
        question: '',
        answer: '',
        note: '',
        sort: 0,
        state: true,
        type: 'camp'
      }
      this.addInfoDialog = true
      this.$nextTick(() => {
        if (this.$refs.addInfoFormRef) {
          this.$refs.addInfoFormRef.clearValidate()
        }
      })
    },
    // 编辑
    handleEdit (row) {
      this.dialogTitle = '编辑问题'
      // 处理状态值：统一转换为布尔值
      let stateValue = row.state
      if (stateValue === 1 || stateValue === '1' || stateValue === true) {
        stateValue = true
      } else if (stateValue === 0 || stateValue === '0' || stateValue === false) {
        stateValue = false
      } else if (stateValue === undefined || stateValue === null) {
        stateValue = true
      }
      this.addInfoModel = {
        id: row.id,
        question: row.question || '',
        answer: row.answer || '',
        note: row.note || '',
        sort: row.sort || 0,
        state: stateValue,
        type: 'camp'
      }
      this.addInfoDialog = true
      this.$nextTick(() => {
        if (this.$refs.addInfoFormRef) {
          this.$refs.addInfoFormRef.clearValidate()
        }
      })
    },
    // 保存
    saveInfo () {
      this.$refs.addInfoFormRef.validate((valid) => {
        if (valid) {
          // 确保 state 是布尔值
          let stateValue = this.addInfoModel.state
          if (stateValue === true || stateValue === 1 || stateValue === '1') {
            stateValue = true
          } else {
            stateValue = false
          }
          const submitData = {
            ...this.addInfoModel,
            state: stateValue
          }

          if (this.addInfoModel.id) {
            // 编辑
            campCommonProblemEdit(submitData).then((res) => {
              this.$message.success('编辑成功')
              this.addInfoDialog = false
              this.getDataList()
            }).catch((err) => {
              console.log('err', err)
              this.$message.error('编辑失败')
            })
          } else {
            // 新增
            campCommonProblemCreate(submitData).then((res) => {
              this.$message.success('新增成功')
              this.addInfoDialog = false
              this.getDataList()
            }).catch((err) => {
              console.log('err', err)
              this.$message.error('新增失败')
            })
          }
        }
      })
    },
    // 删除
    handleDelete (row) {
      this.$confirm('是否确认删除该问题?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        campCommonProblemDel({ id: row.id }).then((res) => {
          this.$message.success('删除成功')
          this.getDataList()
        }).catch((err) => {
          console.log('err', err)
          this.$message.error('删除失败')
        })
      }).catch(() => {})
    },
    // 状态切换
    stateChange (row) {
      // 确保 state 是布尔值
      const stateValue = row.state === true || row.state === 1 || row.state === '1'
      campCommonProblemStatus({ id: row.id, state: stateValue }).then((res) => {
        this.$message.success('状态修改成功')
        // 确保列表中的状态值是布尔值
        row.state = stateValue
        this.getDataList()
      }).catch((err) => {
        console.log('err', err)
        // 如果失败，恢复原状态（取反）
        row.state = !stateValue
        this.$message.error('状态修改失败')
      })
    },
    // 导出（如果需要）
    campProblemsExport () {
      var downLoadUrl = this.$http.defaults.baseURL + 'frequentlyQuestions/exportList'
      var formData = JSON.parse(JSON.stringify(this.queryForm))
      formData.pageSize = 100000
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, '', formData)
    }
  }
}
</script>

<style lang="less" scoped>
.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}
</style>
